window.loadRevolutCheckout = (() => {
    let scriptLoadPromise = null;

    return function () {
        if (document.getElementById('revolut-checkout')) {
            return scriptLoadPromise || Promise.resolve();
        }

        scriptLoadPromise = new Promise((resolve, reject) => {
            const script = Object.assign(document.createElement('script'), {
                src: 'https://merchant.revolut.com/embed.js',
                id: 'revolut-checkout',
                async: true,
                type: 'module',
                onload: resolve,
                onerror: reject,
            });

            document.head.appendChild(script);
        });

        return scriptLoadPromise;
    };
})();
